const PROPERTY = '--zoom-scale'
const PC_BASE_WIDTH = 1280
const TABLET_MIN = 1024
const TABLET_MAX = 1279

function update(): void {
  const w = window.innerWidth
  if (w >= TABLET_MIN && w <= TABLET_MAX) {
    document.documentElement.style.setProperty(PROPERTY, String(w / PC_BASE_WIDTH))
  } else {
    document.documentElement.style.removeProperty(PROPERTY)
  }
}

export function initZoomScale(): void {
  update()
  window.addEventListener('resize', update, { passive: true })
}
